module.exports = __webpack_public_path__ + "img/23cce4032bd28f012fa5635c344af17f.82cc5bc0.jpg";